import Tools from './../components/tools';

export default class Equipe {
    constructor() {
        // Archive labels

        this.toggleDropdown();
        this.selectServices();
        this.removeFilter();
        this.position();
        this.mobileHover();
    }

    toggleDropdown() {
        const form = document.querySelector('#hg_services');
        if(form) {
            form.querySelector('.form__text').addEventListener('click', () => {
                form.classList.toggle('js-open');
            });

            form.querySelector('.form__overlay').addEventListener('click', () => {
                form.classList.remove('js-open');
            });
        }
    }

    selectServices() {
        const select = document.querySelector('#hg_service');
        const list = document.querySelector('#hg_services_ul');

        if(select && list) {
            list.querySelectorAll('.form__item').forEach((item) => {
                item.addEventListener('click', () => {
                    if(!item.classList.contains('js-selected')) {
                        item.classList.add('js-selected');
                        select.querySelector(`[value="${item.dataset.value}"]`).selected = 'selected';
                    } else {
                        item.classList.remove('js-selected');
                        select.querySelector(`[value="${item.dataset.value}"]`).selected = '';
                    }

                    this.setLabel();
                });
            });
        }
    }

    setLabel() {
        const btn = document.querySelector('#hg_services .form__text');
        const select = document.querySelector('#hg_service');
        if(btn && select.querySelectorAll('option:checked').length > 0) {
            let content = '';
            select.querySelectorAll('option:checked').forEach((item, index) => {
                if(index !== 0) {
                    content = `${content}, ${item.textContent}`;
                } else {
                    content = item.textContent;
                }
            });
            btn.innerText = content;
        } else {
            btn.innerText = 'Tous les services';
        }
    }

    removeFilter() {
        const btns = document.querySelectorAll('.tag [data-option]');
        if(btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    btn.remove();
                    document.querySelector(`#hg_service [value="${btn.dataset.option}"]`).selected = '';
                    document.querySelector('#hg_services').submit();
                });
            });
        }
    }

    position() {
        const position = window.location.search;
        if(position.indexOf('team') > -1) {
            const el = document.querySelector('#equipe');
            window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);

            window.scrollTo({
                top: Tools.offset(el).top - document.querySelector('nav.nav').offsetHeight,
                left: 0,
                // behavior: 'smooth',
            });
        }
    }

    mobileHover() {
        if(window.innerWidth < 1024) {
            const elts = document.querySelectorAll('.team__item');
            if(elts.length > 0) {
                elts.forEach((elt) => {
                    elt.querySelector('.team__figure').addEventListener('click', (e) => {
                        e.preventDefault();
                        if(elt.querySelector('.team__figure').classList.contains('js-hover')) {
                            elt.querySelector('.team__figure').classList.remove('js-hover');
                        } else {
                            elt.querySelector('.team__figure').classList.add('js-hover');
                        }
                    });
                });
            }
        }
    }
}